import React, { FC, useEffect, useState } from 'react';
import { IconButton, TextField } from '@material-ui/core';
import { BsEyeFill as ViewIcon } from '@react-icons/all-files/bs/BsEyeFill';
import useSite from 'src/hooks/api/useSite';
import Site from 'src/interfaces/api/Site';
import { Skeleton } from '@material-ui/lab';
import { createUseStyles } from 'src/theming';
import { Link } from 'react-router-dom';

interface Props {
  siteId: string;
}

const useStyles = createUseStyles({
  root: {
    display: 'flex',
  },
});

const SiteField: FC<Props> = ({ siteId }) => {
  const [site, setSite] = useState<Site>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>();
  const { get: getSite } = useSite();
  const classes = useStyles();

  useEffect(() => {
    setError(undefined);
    setLoading(true);

    getSite(siteId)
      .then((site) => {
        setSite(site);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [siteId]);

  if (loading) {
    return <Skeleton height={50} />;
  }

  if (error) {
    return <div style={{ color: '#f44336' }}>{error}</div>;
  }

  return (
    <div className={classes.root}>
      <TextField
        variant='outlined'
        label='Client concerné'
        defaultValue={site?.socialReason}
        InputProps={{
          readOnly: true,
          endAdornment: site?.legacyCustomerId && (
            <IconButton component={Link} to={`/dashboard/customer/${site.legacyCustomerId}`}>
              <ViewIcon color='#0000008a' />
            </IconButton>
          ),
        }}
        fullWidth
      />
    </div>
  );
};

export default React.memo(SiteField);
